<template>
  <v-expansion-panel
    v-if="notEmptyArray(dataArr)"
    class="panel"
  >
    <v-expansion-panel-header
      :style="{ 'color': appColor.textDark }"
      class="panel__header"
    >
      <div
        class="panel__header__icon"
        :style="{ 'background-color': appColor.secondary }"
      />
      <span class="panel__header__title">
        {{ title }}
      </span>
    </v-expansion-panel-header>

    <v-expansion-panel-content class="pt-4">
      <v-simple-table>
        <template #default>
          <thead>
            <tr>
              <th class="header-cell" />
              <th class="header-cell" />
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="item in dataArr"
              :key="item.key"
            >
              <td
                class="left-cell"
                :style="{ 'color': appColor.textDark }"
              >
                {{ item.key }}
              </td>
              <td
                v-if="notEmptyArray(item.value)"
                class="text-left right-cell"
                :style="{ 'color': appColor.textDark }"
              >
                <ul class="right-cell__list">
                  <li
                    v-for="string in item.value"
                    :key="string"
                  >
                    {{ string }}
                  </li>
                </ul>
              </td>
              <td
                v-else
                class="text-right right-cell"
                :style="{ 'color': (item.status && appColor.success) || (item.status === false && appColor.error) || appColor.textDark }"
              >
                {{ item.value }}
              </td>
            </tr>

            <tr
              v-for="downloadData in downloadArr"
              :key="downloadData.title"
            >
              <td
                class="left-cell"
                :style="{ 'color': appColor.textDark }"
              >
                {{ downloadData.title }}
              </td>
              <td class="text-right right-cell">
                <v-btn
                  small
                  class="right-cell__btn"
                  elevation="0"
                  :disabled="downloadCertBtnDisable"
                  :color="appColor.secondary"
                  @click="downloadCertificate(downloadData)"
                >
                  <v-icon
                    left
                    size="16"
                    class="mr-2"
                  >
                    bi-download
                  </v-icon>
                  Скачать
                </v-btn>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import { downloadBase64, isArray } from '@/helpers/helpers'
import { mapActions } from 'vuex'

export default {
  name: 'ResultTable',

  props: {
    dataArr: {
      type: Array,
      require: true,
      default: null
    },
    title: {
      type: String,
      require: false,
      default: ''
    },
    /* Необходимы поля .fileBase64, .name, .title */
    downloadArr: {
      type: Array,
      require: false,
      default: () => []
    }
  },

  data () {
    return {
      panelStates: [],
      appColor: this.$appConfig.color,
      downloadCertBtnDisable: false
    }
  },

  methods: {
    ...mapActions('notification', ['showError']),

    notEmptyArray (arr) {
      return isArray(arr)
    },

    downloadCertificate (data) {
      if (!data.fileBase64.length) {
        this.showError('Не удалось найти файл')
        return
      }

      this.downloadCertBtnDisable = true

      downloadBase64(
        data.fileBase64,
        data.mime || 'application/pkix-cert',
        data.name || 'certificate.cer'
      )

      setTimeout(() => {
        this.downloadCertBtnDisable = false
      }, 1000)
    }
  }
}
</script>

<style lang="scss" scoped>
  .panel {
    overflow: hidden;

    &__header {
      position: relative;
      min-height: 60px;
      font-weight: bold;
      border-radius: 0 !important;

      &__icon {
        position: absolute;
        left: 0;
        top: 0;
        width: 10px;
        height: 100%;
        background-color: $color-secondary;
      }

      &__title {
        font-weight: 600;
      }
    }
  }

  .header-cell {
    border-bottom: none !important;
    height: 0 !important;
  }

  .title-text {
    font-size: 1rem;
    word-break: break-word;

    @media(max-width: $cp-mobile-breakpoint) {
      font-size: 0.9rem;
    }
  }

  .left-cell {
    @include left-cell;
  }

  .right-cell {
    @include right-cell;

    &__list {
      min-width: 30vw;

      @media(max-width: $cp-mobile-breakpoint) {
        width: 60vw;
      }
    }

    &__btn {
      @include cp-button;
    }
  }

  .text-success {
    color: $color-success;
  }

  .text-error {
    color: $color-error;
  }
</style>
